import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import IWidget from '../../../app/_interfaces/IWidget';

@Injectable({
  providedIn: 'root',
})
export class WidgetsService {
  constructor(private http: HttpClient) {}

  getAll(customers_id: number) {
    return this.http.get<IWidget[]>(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customers_id}/widgets`,
      {}
    );
  }
}
